import { CSSObject } from '@chakra-ui/react';
import { EWithdrawalStatus } from '../../../../lib/DBModels';
import { TWithdrawalStatus } from '../RequestedWithdrawalCard/styles/RequestedWithdrawalCard.styles';
import { CustomButtonProps } from '@/components/Button/Button';

export const Heading: CSSObject = {
  alignItems: 'center',
  color: 'white',
  display: 'flex',
  fontSize: 'sm',
  fontWeight: 'medium',
  mb: '1',
};

export const BackButton: CSSObject = {
  h: '6',
  minW: '6',
};

export const TextDescription: CSSObject = {
  fontSize: '11px',
  color: 'white',
  fontWeight: 'medium',
};

export const DividerWithdrawal: CSSObject = {
  borderColor: 'blackAlpha.400',
  borderTop: '2px',
  opacity: '1',
  boxShadow: '0px 1px 0px 0px rgba(105, 109, 219, 0.20)',
};

export const BankCardContainer: CSSObject = {
  mt: '-3',
};

export const BankRadioWrapper: CSSObject = {
  borderBottom: '1px dashed',
  borderBottomColor: 'gray.300',
  px: '0',
  py: '3',
  pl: '2',
};

export const TextBankAccountName: CSSObject = {
  fontSize: 'sm',
  lineHeight: 'normal',
  mb: '1',
  color: 'gamma.900',
};

export const FlexBankDetailsContainer: CSSObject = {
  fontSize: 'xs',
  gap: '4',
  lineHeight: 'normal',
  color: 'gamma.900',
};

export const TextBankAccountDetail: CSSObject = {
  color: 'gray.500',
};

export const AmountInputWrapperWithdrawal: CSSObject = {
  mt: '2',
};

export const buttonAddAccountProps: CustomButtonProps = {
  variant: 'secondary',
  borderRadius: 'base',
  fontSize: 'xs',
};

export const IncreaseAmountWrapper: CSSObject = {
  gap: '1',
  mb: '1',
};

export const ButtonIncrease: CSSObject = {
  bg: 'gamma.500',

  _hover: {
    bg: 'gamma.600',
  },

  _active: {
    bg: 'gamma.700',
  },
};

export const ListContainer: CSSObject = {
  bg: 'transparent',
  boxShadow: 'none',
  ml: [null, null, '4'],
  mt: '2',
  p: '0',
};

export const ListContainerHeading: CSSObject = {
  display: 'none',
};

export const WithdrawalWrapper: CSSObject = {
  bg: 'delta.50',
  borderColor: 'delta.200',
  boxShadow: 'none',
  color: 'gray.700',
  m: '0',
  p: '2.5',

  '& + &': {
    mt: '2',
  },
};

export const WithdrawalCardDetail: CSSObject = {
  borderBottom: '0',
  fontSize: 'xs',
  fontWeight: 'bold',
  py: '1.5',

  _first: {
    color: 'gray.500',
    fontSize: '2xs',
  },
};

export const WithdrawalStatus = ({ status }: TWithdrawalStatus): CSSObject => ({
  bg: status === EWithdrawalStatus.Pending && 'delta.300',
  color: status === EWithdrawalStatus.Pending && 'gamma.800',
  fontSize: '2xs',
  px: '1',
  py: '0.5',
  textTransform: 'uppercase',
});

export const ButtonWithdrawalCardCancel: CSSObject = {
  fontSize: undefined,
  p: undefined,
};

export const Subheading: CSSObject = {
  color: 'white',
  fontSize: 'xs',
};

export const InputWithdrawal: CSSObject = {
  _hover: {
    bg: 'gamma.100',
    border: '1px',
    borderColor: 'gamma.500',
  },
  _focus: {
    bg: 'gamma.100',
    border: '2px',
    borderColor: 'gamma.500',
  },
};

export const InputWrapperWithdrawal: CSSObject = {
  '.chakra-form-control': {
    '.chakra-input': {
      bg: 'gamma.100',
      _focus: {
        bg: 'gamma.200',
        border: '2px',
        borderColor: 'gamma.500',
      },
      _hover: {
        bg: 'gamma.100',
        border: '1px',
        borderColor: 'gamma.500',
      },
    },
    '.chakra-form__label': {
      color: 'white',
      fontSize: '13px',
      fontWeight: 'semibold',
      lineHeight: '133%',
    },
    '.chakra-form__helper-text': {
      color: 'white',
      fontSize: 'xs',
      fontWeight: 'medium',
    },
  },
};
